import React, { useState } from 'react';
import Calculator from './components/Calculator';
import ContentSection from './components/ContentSection';
import FooterLinks from './components/FooterLinks';
import { tepCriteria, tvpCriteria } from './data/criteria';

import DoutoBanner from './DoutoBanner';
const tabs = [
  { id: 'TEP', label: 'Wells para TEP' },
  { id: 'TVP', label: 'Wells para TVP' },
];

function App() {
  const [activeTab, setActiveTab] = useState('TEP');

  return (
    <div className="site-shell">
      <header className="site-header">
        <a href="/" aria-label="Calculadora Wells, início" className="brand logo"><svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><rect x="7" y="3" width="4" height="26" fill="currentColor"/><rect x="21" y="3" width="4" height="26" fill="currentColor"/><circle cx="16" cy="16" r="5" fill="var(--logo-accent)"/></svg><span>Escore de Wells</span></a>
        <span className="header-note">Probabilidade clínica pré-teste</span>
      </header>

      <main className="page-content">
        <div id="calculadora">
        <nav className="calculator-tabs" aria-label="Escolha da calculadora">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`calculator-tab ${activeTab === tab.id ? 'is-active' : ''}`}
              aria-selected={activeTab === tab.id}
              role="tab"
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <div role="tabpanel" hidden={activeTab !== 'TEP'}>
          <Calculator
            criteria={tepCriteria}
            type="TEP"
            headingLevel={1}
            title="Calculadora de Wells para TEP"
            description="Organize os critérios e visualize a probabilidade pré-teste para TEP."
          />
        </div>

        <div role="tabpanel" hidden={activeTab !== 'TVP'}>
          <Calculator
            criteria={tvpCriteria}
            type="TVP"
            title="Calculadora de Wells para TVP"
            description="Avalie os critérios clínicos de TVP e acompanhe a pontuação em tempo real."
          />
        </div>
        </div>

        <DoutoBanner />
        <ContentSection />
        <FooterLinks />
      </main>
    </div>
  );
}

export default App;
